import { render, staticRenderFns } from "./CommercialPartnerView.vue?vue&type=template&id=ac197204"
import script from "./CommercialPartnerView.vue?vue&type=script&lang=js"
export * from "./CommercialPartnerView.vue?vue&type=script&lang=js"
import style0 from "./CommercialPartnerView.vue?vue&type=style&index=0&id=ac197204&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports